import React, { useState } from "react";
import { App, Modal } from "antd5";

import Button from "components/ui/button/Button";
import { useCreateNoticeList } from "lib/hooks/api/notices/lists/useCreateNoticeList";
import { ListForm } from "./UserListsModals";

type AddNewListButtonProps = {
  modal?: boolean;
};

export function AddNewListButton({ modal }: AddNewListButtonProps): JSX.Element {
  const { message } = App.useApp();
  const { mutate: createList, isLoading } = useCreateNoticeList({
    onSuccess: () => {
      message.success("Notice list created successfully!");
      setIsModalOpen(false);
    },
    onError: () =>
      message.error("Unable to create your lists. Please contact us if the problem persists"),
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      {isModalOpen &&
        (modal ? (
          <Modal title="Create list" open={true} closable={false} footer={null}>
            <ListForm
              onSubmit={(data) => createList({ input: { name: data.name } })}
              onCancel={() => setIsModalOpen(false)}
              listName=""
              isSubmitting={isLoading}
            />
          </Modal>
        ) : (
          <ListForm
            onSubmit={(data) => createList({ input: { name: data.name } })}
            onCancel={() => setIsModalOpen(false)}
            listName=""
            isSubmitting={isLoading}
          />
        ))}
      {(modal || !isModalOpen) && (
        <Button icon="plus" onClick={() => setIsModalOpen(true)}>
          Create list
        </Button>
      )}
    </div>
  );
}
